import * as widgetConstants from "./constants";

export const participationTypes = (locale) => [
    {
        value: 'online',
        label: locale.get('participationType.online'),
    },
    {
        value: 'offline',
        label: locale.get('participationType.offline'),
    },
];

export const registrationErrors = {
    [widgetConstants.STATUS_NO_ACCESS]: {
        hasError: true,
        name: 'registration.accessClosed',
    },
    [widgetConstants.STATUS_WRONG_FORMAT]: {
        hasError: true,
        name: 'registration.wrongFormat',
    },
    [widgetConstants.STATUS_ENTER_EMAIL]: {
        hasError: true,
        name: 'registration.enterEmail',
    },
    [widgetConstants.STATUS_ALREADY_REGISTERED]: {
        hasError: true,
        name: 'registration.alreadyRegistered',
    },
    [widgetConstants.STATUS_NOT_SPECIFIED]: {
        hasError: true,
        name: '',
    },
    [widgetConstants.STATUS_USE_CORPORATE_MAIL]: {
        hasError: true,
        name: 'registration.useCorporateMail',
    },
};

export const responseErrorsMessage = {
    [widgetConstants.STATUS_NO_ACCESS]: 'registration.emailNotAllowed',
    [widgetConstants.STATUS_WRONG_FORMAT]: 'registration.emailWrongFormat',
    [widgetConstants.STATUS_NOT_SPECIFIED]: 'registration.emailNotSpecified',
};

export const uploadPhotoRequirements = {
    [widgetConstants.REQUIREMENT_FORMAT] : "registration.addPhoto.requirements.format",
    [widgetConstants.REQUIREMENT_WEIGHT] : "registration.addPhoto.requirements.weight",
    [widgetConstants.REQUIREMENT_SIZE] : "registration.addPhoto.requirements.size",
    [widgetConstants.REQUIREMENT_FACE] : "registration.addPhoto.requirements.face",
    [widgetConstants.REQUIREMENT_ACCESSORIES] : "registration.addPhoto.requirements.accessories",
};

export const uploadPhotoErrors = {
    [widgetConstants.PHOTO_ERROR_FORMAT] : 'registration.addPhoto.error.format',
    [widgetConstants.PHOTO_ERROR_SIZE] : 'registration.addPhoto.error.size',
};
